/**
 * 智能助手话术（WS type=2000）解析
 * 新结构: message = JSON字符串
 *   [{ name: "千问", response: "句1\\n句2\\n句3" }, ...]
 * 多句分隔：换行，或英文 | / 中文 ｜
 * 兼容旧结构: response 为 [{ utter1: "..." }, ...]
 */

export function parseAiAssistantMessage(message) {
  if (typeof message === "string") {
    const trimmed = message.trim();
    if (!trimmed) return [];
    return JSON.parse(trimmed);
  }
  if (Array.isArray(message)) return message;
  return [];
}

/** 按换行或中英文竖线拆成多条话术 */
function splitResponseParts(text) {
  return String(text)
    .split(/\r?\n|[|｜]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

/** 从单条模型的 response 抽出可用话术文本列表 */
export function extractAiResponseTexts(response) {
  if (response == null || response === "") return [];

  if (typeof response === "string") {
    const lines = splitResponseParts(response);
    if (lines.length > 0) return lines;
    const whole = response.trim();
    return whole ? [whole] : [];
  }

  if (Array.isArray(response)) {
    const list = [];
    response.forEach((item) => {
      if (typeof item === "string") {
        const t = item.trim();
        if (t) list.push(t);
        return;
      }
      if (item && typeof item === "object") {
        const keys = Object.keys(item);
        if (keys.length > 0) {
          const t = String(item[keys[0]] || "").trim();
          if (t) list.push(t);
        }
      }
    });
    return list;
  }

  return [];
}

/** 当前客服微信号：个人设置-基础信息 wechatNumber */
export function getAgentWechat() {
  try {
    const account = JSON.parse(localStorage.getItem("account") || "null") || {};
    return String(account.wechatNumber || account.wechat || "").trim();
  } catch (e) {
    return "";
  }
}

/** 替换话术中的客服变量，如 ${agent_wechat} */
export function fillAgentPlaceholders(text) {
  if (text == null) return "";
  const wechat = getAgentWechat();
  return String(text).replace(/\$\{\s*agent_wechat\s*\}/gi, wechat);
}

export function buildAiAssistantItems(payload) {
  const data = payload || {};
  const messageArray = parseAiAssistantMessage(data.message);
  const items = [];
  const stamp = Date.now();

  messageArray.forEach((model, modelIndex) => {
    const modelName = (model && model.name) || "模型" + (modelIndex + 1);
    const texts = extractAiResponseTexts(model && model.response);
    texts.forEach((content, respIndex) => {
      items.push({
        id: "ai_" + modelIndex + "_" + respIndex + "_" + stamp,
        modelName,
        content: String(content),
      });
    });
  });

  return {
    cid: data.cid || "",
    sid: data.sid || "",
    items,
  };
}
